var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c("div", { staticClass: "contents_wrap" }, [
      _c("h2", { staticClass: "pg_title" }, [
        _vm._v("Service Bulletin - Mobile (English) Detail")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sub_tit" }, [_vm._v("Basic Info.")]),
      _vm._v(" "),
      _c("table", { staticClass: "create_table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", [_vm._v("Date")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.view.reg_dt))]),
            _vm._v(" "),
            _c("th", [_vm._v("Register")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.view.reg_user_id))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("Type")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(_vm.view.type1) + " / " + _vm._s(_vm.view.type2))
            ]),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            _c("th")
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("Urgency")]),
            _vm._v(" "),
            _c("td", [
              _vm.view.urgency_yn === "Y"
                ? _c(
                    "label",
                    { class: { txt_red: _vm.view.urgency_yn === "Y" } },
                    [_vm._v("Urgent")]
                  )
                : _c("label", [_vm._v("Normal")])
            ]),
            _vm._v(" "),
            _c("th", [_vm._v("Need Translation")]),
            _vm._v(" "),
            _c("td", [
              _c(
                "label",
                { class: { txt_red: _vm.view.need_reprocess === "Y" } },
                [_vm._v(_vm._s(_vm.view.need_reprocess))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("Required Translations")]),
            _vm._v(" "),
            _c("td", { staticClass: "txt_red", attrs: { colspan: "3" } }, [
              _vm._v(_vm._s(_vm.view.tran))
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("Title")]),
            _vm._v(" "),
            _c("td", { attrs: { colspan: "3" } }, [
              _vm._v(_vm._s(_vm.view.title))
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("Tag Info")]),
            _vm._v(" "),
            _c("td", { attrs: { colspan: "3" } }, [
              _vm._v(_vm._s(_vm.view.tag_info))
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("User Level")]),
            _vm._v(" "),
            _c("td", { attrs: { colspan: "3" } }, [
              _c(
                "ul",
                { staticClass: "ul_list max_scrollbar" },
                _vm._l(_vm.userLevelList, function(level) {
                  return _c(
                    "li",
                    { key: level.CODE_ID, staticClass: "userlevel_txt" },
                    [
                      _vm._v(
                        _vm._s(level.CODE_ID) +
                          " (" +
                          _vm._s(level.CODE_NAME) +
                          ")"
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("Country / Region")]),
            _vm._v(" "),
            _c("td", { attrs: { colspan: "3" } }, [
              _c(
                "ul",
                { staticClass: "ul_list max_scrollbar" },
                _vm._l(_vm.countryList, function(country) {
                  return _c(
                    "li",
                    { key: country, staticClass: "userlevel_txt" },
                    [_vm._v(_vm._s(country))]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("Contents")]),
            _vm._v(" "),
            _c("td", { attrs: { colspan: "3" } }, [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.view.content) } })
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("Attachment")]),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "no_padding", attrs: { colspan: "3" } },
              [
                _vm.fileList.length > 0
                  ? _c("innorix-download", {
                      attrs: {
                        uploadId: _vm.uploadId,
                        serviceType: "mail",
                        attachList: _vm.fileList,
                        seq: _vm.view.seq
                      }
                    })
                  : _c("span", [
                      _vm._v(
                        "\n                            No Attachment\n                        "
                      )
                    ]),
                _vm._v(" "),
                _vm.fileList.length > 0
                  ? _c("dl", { staticClass: "attachment_link" }, [
                      _c("dt", [
                        _c(
                          "a",
                          {
                            staticClass: "txt_link",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.toggleLink($event)
                              }
                            }
                          },
                          [_vm._v("Having trouble downloading?")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _c(
                          "ul",
                          _vm._l(_vm.fileList, function(file) {
                            return _c("li", { key: file.FILE_DIR }, [
                              _c(
                                "a",
                                {
                                  staticClass: "txt_link",
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.getDownloadUrl(
                                        file.ATTCH_FILE_SEQ
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "ico_attach" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(file.FILE_NM) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1442670a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1442670a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/common/ServiceBulletinViewer.vue
// module id = wh3/
// module chunks = 0